import { FullName } from '@/features/profile/profile.types';

/**
 * Generates a full name with optional middle initial and designation
 * @param {FullName} data
 * @returns string
 */
function useFullName(data: FullName): string {
  const { firstName, middleInitial, lastName, designation } = data;

  const formattedFirstName = `${firstName} `;
  const formattedMiddleInitial = middleInitial ? `${middleInitial} ` : '';
  const formattedLastName = `${lastName}`;
  const formattedDesignation = designation ? `, ${designation}` : '';

  return `${formattedFirstName}${formattedMiddleInitial}${formattedLastName}${formattedDesignation}`;
}

export default useFullName;
